// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

if (!customElements.get('article-carousel')) {
  customElements.define(
    'article-carousel',
    class ArticleCarousel extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (this.els.slide.elements.length > 2) {
          this.els.slides.element.setAttribute(
            'data-custom-cursor-external-el',
            'carousel'
          )
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.1,
          slides: '.car-Carousel_Slide',
          spacing: 15,
          breakpoints: {
            '(min-width: 768px)': {
              centered: true,
              controls: this.els.slide.elements.length > 2,
              loop: true,
              mode: 'snap',
              slidesPerView: 2.1,
              spacing: 30
            }
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide
              )
            })
          }
        })
      }
    }
  )
}
